    
       <template>
  <div class="container-fluid" style="padding-top: 56px;overflow: scroll;">
    <!-- Heading Row -->

    <div class="row">
      <b-img :src="`${publicPath}oforis2.png`" style="display:block;width:100%;margin-top:-10vh;" class="mypic nonmobile"></b-img>
      <b-img :src="`${publicPath}oforis3.png`" style="margin-top:7vh;margin-bottom:5vh;" fluid class="mobile "></b-img>

    </div>
    <div
      class=" row"
      style="background-color: white; margin-top: -8vh; padding: 5vh;text-align: left; float: left;"
    >
    <div class="col-12">
      <h2>
        <strong
          >Vers quel organisme me tourner pour la prise en charge de ma
          formation&nbsp;?</strong
        >
      </h2>
      <br />
      <p>
        L'orientation vers votre possible financement d&eacute;pend de votre
        statut.
      </p>
      <p>
        <em
          >Attention, pour que le financeur dont vous d&eacute;pendez accorde le
          financement, il y a un d&eacute;lai plus ou moins long selon
          l&rsquo;organisme, parfois 3 mois. Aussi, si vous souhaitez &ecirc;tre
          financ&eacute; avant la formation il faut choisir une date
          suffisamment &eacute;loign&eacute;e pour avoir le temps de soumettre
          le dossier.
        </em>
      </p>
      <p>
        Voici les principaux statuts possibles selon la nature du payeur de la
        formation.
      </p>
      <br />
      <ol>
        <li>
          <strong>
            Entreprise qui paie pour former un ou plusieurs
            salari&eacute;s</strong
          >
        </li>
      </ol>
      <p>
        L'entreprise doit se rapprocher de son OPCO&nbsp;(qui remplace les
        OPCA). S'il ne sait pas de quel OPCO, il d&eacute;pend, il peut poser la
        question &agrave; son expert-comptable et/ou l'identifier selon sa
        convention collective gr&acirc;ce &agrave; la liste suivante :&nbsp;<a
          href="https://www.centre-inffo.fr/site-droit-formation/site-fiches-pratiques/annexes/presentation-des-11-operateurs-de-competences-opco"
          >cliquez-ici pour la liste des OPCO</a
        >.
      </p>
      <p>
        Rappel : toutes les entreprises ont l'obligation de cotiser annuellement
        aupr&egrave;s d'un OPCO&nbsp;s'ils ont des salari&eacute;s, ils savent
        donc en g&eacute;n&eacute;ral de qui ils d&eacute;pendent.
      </p>
      <p>
        Pour vous aider, voici la liste des OPCO&nbsp;avec les moyens de les
        contacter :
      </p>
      </div>
      <div class="col-12">
      <table style="margin-top:2vh;">
        <tbody>
          <tr>
            <td>
              <p><strong>OPCO</strong></p>
            </td>
            <td>
              <p><strong>OPCA CORRESPONDANTS</strong></p>
            </td>
            <td>
              <p><strong>COORDONN&Eacute;ES</strong></p>
            </td>
          </tr>
          <tr>
            <td>
              <p><strong>AFDAS</strong></p>
            </td>
            <td>
              <p>AFDAS, FAFIH, OPCALIA, UNIFORMATION</p>
            </td>
            <td>
              <p>
                66 rue Stendhal - CS 32016<br />75990 Paris cedex 20<br />01 44
                78 39 39
              </p>
              <p><a href="https://www.afdas.com/">afdas.com/</a></p>
            </td>
          </tr>
          <tr>
            <td>
              <p><strong>ATLAS</strong></p>
            </td>
            <td>
              <p>OPCABAIA, ACTALIAN, AGEFOS-PME, FAFIEC, OPCALIA</p>
            </td>
            <td>
              <p>148 boulevard Haussmann<br />75008 Paris</p>
              <p>01 43 46 01 10</p>
              <p><a href="https://opco-atlas.fr/">opco-atlas.fr/</a></p>
            </td>
          </tr>
          <tr>
            <td>
              <p><strong>OCAPIAT</strong></p>
            </td>
            <td>
              <p>FAFSEA, OPCALIM, AGEFOS-PME (FAF PECHE), INTERGROS</p>
            </td>
            <td>
              <p>128 rue de la Bo&eacute;tie - lot 41<br />75008 Paris</p>
              <p>01 70 38 38 38</p>
              <p><a href="https://www.ocapiat.fr/">www.ocapiat.fr/</a></p>
            </td>
          </tr>
          <tr>
            <td>
              <p><strong>OPCO COHESION SOCIALE</strong></p>
            </td>
            <td>
              <p>UNIFORMATION, FAFSEA</p>
            </td>
            <td>
              <p>43 boulevard Diderot<br />75012 Paris</p>
              <p>01 53 02 13 13</p>
              <p>
                <a href="https://www.uniformation.fr/">www.uniformation.fr/</a>
              </p>
            </td>
          </tr>
          <tr>
            <td>
              <p><strong>OPCO DE LA CONSTRUCTION</strong></p>
            </td>
            <td>
              <p>CONSTRUCTYS, INTERGROS</p>
            </td>
            <td>
              <p>
                32 rue Ren&eacute; Boulanger - CS 60033<br />75483 Paris cedex
                10
              </p>
              <p>01 82 83 95 00</p>
              <p>
                <a href="https://www.constructys.fr/">www.constructys.fr/</a>
              </p>
            </td>
          </tr>
          <tr>
            <td>
              <p><strong>OPCOMMERCE</strong></p>
            </td>
            <td>
              <p>FORCO, AGEFOS-PME, FAFSEA, INTERGROS</p>
            </td>
            <td>
              <p>251 boulevard Pereire<br />75852 Paris cedex 17</p>
              <p>01 55 37 41 51</p>
              <p>
                <a href="https://www.lopcommerce.com/">www.lopcommerce.com/</a>
              </p>
            </td>
          </tr>
          <tr>
            <td>
              <p><strong>AKTO</strong></p>
            </td>
            <td>
              <p>
                FAF-TT, FAFIH, ACTALIANS, OPCA TRANSPORTS ET SERVICES, OPCALIA,
                AGEFOSPME, INTERGROS
              </p>
            </td>
            <td>
              <p>14 rue Riquet<br />75940 Paris cedex 19</p>
              <p><a href="https://www.akto.fr/">www.akto.fr/</a></p>
            </td>
          </tr>
          <tr>
            <td>
              <p><strong>OPCO 2i</strong></p>
            </td>
            <td>
              <p>OPCAIM, AGEFOS-PME, OPCA DEFI, OPCALIA, OPCA 3+</p>
            </td>
            <td>
              <p>55 rue de Ch&acirc;teaudun<br />75009 Paris</p>
              <p>08 05 69 03 57</p>
              <p><a href="https://www.opco2i.fr/">www.opco2i.fr/</a></p>
            </td>
          </tr>
          <tr>
            <td>
              <p><strong>OPCO MOBILIT&Eacute;S</strong></p>
            </td>
            <td>
              <p>ANFA, AGEFOS-PME, OPCALIA, OPCA TRANSPORTS ET SERVICES</p>
            </td>
            <td>
              <p>43 bis route de Vaugirard<br />92190 Meudon</p>
              <p>01 41 14 16 18</p>
              <p>
                <a href="https://www.opcomobilites.fr/"
                  >www.opcomobilites.fr/</a
                >
              </p>
            </td>
          </tr>
          <tr>
            <td>
              <p><strong>OPCO ENTREPRISES DE PROXIMIT&Eacute;</strong></p>
            </td>
            <td>
              <p>ACTALIANS, AGEFOS PME, FAFSEA, OPCALI, OPCALIM</p>
            </td>
            <td>
              <p>53 rue Amp&egrave;re<br />75017 Paris</p>
              <p><a href="https://www.opcoep.fr/">www.opcoep.fr/</a></p>
            </td>
          </tr>
          <tr>
            <td>
              <p><strong>OPCO SANT&Eacute;</strong></p>
            </td>
            <td>
              <p>UNIFAF, ACTALIANS, OPCALIA</p>
            </td>
            <td>
              <p>31 rue Anatole France<br />92300 Levallois Perret</p>
              <p>01 49 68 10 10</p>
              <p><a href="https://www.opco-sante.fr/">www.opco-sante.fr/</a></p>
            </td>
          </tr>
        </tbody>
      </table>
      </div>
      <div class="col-12">
      <br />
      <ol start="2">
        <li>
          <strong>
            Micro-entrepreneur (auto-entrepreneur) ou Dirigeant non
            salari&eacute; qui paie pour suivre la formation</strong
          >
        </li>
      </ol>
      <p>
        Dans cette hypoth&egrave;se, vous ne d&eacute;pendez non plus d'un OPCA
        mais d'un Fond d'Assurance Formation (FAF).
      </p>
      <p>
        Les modalit&eacute;s de financement varient d'un FAF &agrave; l'autre.
        Pour savoir de quel FAF d&eacute;pend vous d&eacute;pendez, vous devez
        obtenir votre attestation de contribution &agrave; la formation
        professionnelle aupr&egrave;s de l'URSSAF ou de la
        s&eacute;curit&eacute; sociale des ind&eacute;pendants.
      </p>
      <p>Vous pouvez ensuite directement contacter votre FAF :</p>
    
      </div>
      <div class="col-12" style="margin-top:2vh;">
      <table >
        <tbody>
          <tr>
            <td >
              <p><strong>FAF</strong></p>
            </td>
            <td >
              <p><strong>T&eacute;l&eacute;phone</strong></p>
            </td>
            <td >
              <p><strong>Site web</strong></p>
            </td>
          </tr>
          <tr>
            <td>
              <p><strong>FIF-PL</strong></p>
              <p>104, rue de Miromesnil - 75384 Paris Cedex 08</p>
            </td>
            <td >
              <p>01 55 80 50 00</p>
            </td>
            <td >
              <p>
                <a href="http://www.fifpl.fr/index.php"
                  >http://www.fifpl.fr/index.php</a
                >
              </p>
            </td>
          </tr>
          <tr>
            <td>
              <p><strong>AGEFICE</strong></p>
              <p>16, avenue de Friedland - 75008 Paris</p>
            </td>
            <td >
              <p>01 44 69 80 10</p>
            </td>
            <td >
              <p>
                <a href="http://communication-agefice.fr/"
                  >http://communication-agefice.fr/</a
                >
              </p>
            </td>
          </tr>
          <tr>
            <td>
              <p><strong>FAFCEA</strong></p>
              <p>14, rue Chapon - 75003 Paris</p>
            </td>
            <td >
              <p>01 53 01 05 22</p>
            </td>
            <td >
              <p>
                <a href="https://www.fafcea.com/">https://www.fafcea.com/</a>
              </p>
            </td>
          </tr>
          <tr>
            <td>
              <p><strong>VIVEA</strong></p>
              <p>81, bd Berthier - 75017 Paris</p>
            </td>
            <td >
              <p>01 56 33 29 00</p>
            </td>
            <td >
              <p><a href="https://www.vivea.fr/">https://www.vivea.fr/</a></p>
            </td>
          </tr>
          <tr>
            <td>
              <p><strong>FAF-PM</strong></p>
              <p>11, bd de Sebastopol - 75001 Paris</p>
            </td>
            <td >
              <p>01 49 70 85 40</p>
            </td>
            <td >
              <p><a href="https://www.fafpm.org/">https://www.fafpm.org/</a></p>
            </td>
          </tr>
        </tbody>
      </table>
      </div>
      <div class="col-12">
      <br />
      <ol start="3">
        <li><strong> Particulier qui paie &agrave; ses frais</strong></li>
      </ol>
      <p>
        Les dossiers de remboursement ne sont pas compatibles avec un
        financement CPF, ainsi si c'est vous &ecirc;tes un particulier qui paie
        directement, &agrave; vous de vous renseigner directement sur les
        modalit&eacute;s possibles au sein de votre ville, d&eacute;partement ou
        encore r&eacute;gion.
      </p>
      </div>
    </div>
  </div>
</template>
       
<script>
export default {
  data() {
    return {
      publicPath: process.env.BASE_URL,
    };
  },
};
</script>

       <style>

@media screen and (max-width: 600px) {
  .mypic {
    margin-top: 0vh !important;
    height: auto;
  }
}
table, td, th {
            border: 1px solid black;
            width: 100%;

            text-align: center;
         }

@media (max-width: 600px) {
  .nonmobile {
    visibility: hidden;
    clear: both;
    float: left;
    margin: 10px auto 5px 20px;
    width: 28%;
    height: 7vh;
    display: none;
  }
}
@media (min-width : 600px) {
         .mobile{
           visibility: hidden;
    clear: both;
    float: left;
    margin: 10px auto 5px 20px;
    max-width: 100%;
    height:auto;
    display: none;
         } 
}
</style>